import { render, staticRenderFns } from "./TagDetail.vue?vue&type=template&id=4a4cb468&scoped=true&"
import script from "./TagDetail.vue?vue&type=script&lang=js&"
export * from "./TagDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4cb468",
  null
  
)

export default component.exports